import { Analysis } from "../ars_ldm";
import { isDocumentReference } from "./isDocumentReference";
import { isExtensibleTerminologyTerm } from "./isExtensibleTerminologyTerm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is an Analysis.
 *
 * @param obj - The value to check.
 * @returns True if the value is an Analysis.
 */
export const isAnalysis = (obj: unknown): obj is Analysis => {
  if (!isObjectRecord(obj)) return false;
  if (!isNamedObject(obj)) return false;

  if (typeof obj.id !== "string") return false;
  if (!isExtensibleTerminologyTerm(obj.reason)) return false;
  if (!isExtensibleTerminologyTerm(obj.purpose)) return false;
  if (typeof obj.methodId !== "string") return false;

  if (!["number", "undefined"].includes(typeof obj.version)) return false;
  if (
    obj.documentRefs !== undefined &&
    (!Array.isArray(obj.documentRefs) ||
      obj.documentRefs.some((documentRef) => !isDocumentReference(documentRef)))
  ) {
    return false;
  }

  return true;
};
